module.exports = __webpack_public_path__ + "img/facebook.9b1e735f.svg";